var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26459)",
    d: "m15.117 7.5586c-4.1574 0-7.5586 3.4012-7.5586 7.5586v26.457c0 2.0787 0.83208 3.9688 2.2305 5.3672l6.3026 6.0483v-8.9659c0-2.1264 3.7765-3.9351 5.9029-3.9351h8.3672c2.1264 0 5.6344 1.7123 5.6925 3.8379l0.24709 9.0436h7.9546c2.1264 0 3.8398 2.9621 3.8398 5.0884v8.3672c0 2.1264-1.6317 5.1972-3.758 5.1972h-10.027l9.4924 9.3321c1.3606 1.3606 3.2514 2.1934 5.3301 2.1934s3.9675-0.83208 5.3281-2.2305l26.457-26.457c1.3984-1.3606 2.2305-3.2494 2.2305-5.3281s-0.86987-4.0066-2.2305-5.3672l-34.016-34.016c-1.3606-1.3606-3.2494-2.1914-5.3281-2.1914zm5.6699 7.5586c3.1369 0 5.668 2.533 5.668 5.6699s-2.531 5.668-5.668 5.668c-3.1369 0-5.6699-2.531-5.6699-5.668 0-3.1369 2.533-5.6699 5.6699-5.6699z",
    strokeWidth: 3.7794
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 0.18521
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.0538,
    y: 14.708,
    width: 9.7599,
    height: 3.5212,
    ry: 0.84237,
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 11.589,
    y: -8.6943,
    width: 9.7599,
    height: 3.5212,
    ry: 0.84237,
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBrand);
export default __webpack_public_path__ + "static/media/add_brand.463933a5f3aea311c37fc0eae40eb073.svg";
export { ForwardRef as ReactComponent };